// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { IndividualTabPropsQuote } from "@/components/wpl/tab-group/src";
import { Row } from "@/libraries/wpl/foundations/src";
import TabsQuote from "@/patterns/wpl/tabs-quote/src";

export type TabsSectionProps = {
    readonly headerText: string;
    readonly tabs: IndividualTabPropsQuote[];
};

const TabsSection = ({ headerText, tabs }: TabsSectionProps) => {
    const tabsSectionStyle = css({
        "paddingBlockStart": "64px",

        ".jira-product-discovery-tabs": {
            "color": "#253858",
            "paddingBlockStart": "48px",
            [media.above.md]: {
                paddingBlockStart: "16px"
            },
            "paddingBlockEnd": "16px",
            "marginBlockStart": "40px",

            ".tab-panels": {
                paddingBlockStart: "32px"
            }
        },
        ".quote-blurb": {
            fontWeight: 500
        },
        ".tab-group-inner button": {
            "borderWidth": "1px",
            "borderStyle": "solid",
            "borderColor": "#ffffff00",
            "&:hover": {
                borderColor: "#c1c7d0"
            }
        },
        ".horizontal-rule": {
            paddingBlockStart: "16px",
            paddingBlockEnd: "16px",
            hr: {
                width: "100%",
                margin: "0 auto 40px",
                background: "#dfe1e5",
                height: "2px",
                border: "none"
            }
        },
        "backgroundImage":
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2.webp)",
        "backgroundPosition": "top left",
        "backgroundRepeat": "no-repeat",
        "backgroundSize": "240px",

        [media.above.md]: {
            backgroundPosition: "top left -60px",
            backgroundSize: "330px"
        },
        [media.above.lg]: {
            backgroundImage:
                "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2.webp), url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg3.webp), url(https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2-1.webp)",
            backgroundPosition: "top left, top 45px right, bottom left -60px",
            backgroundRepeat: "no-repeat , no-repeat , no-repeat",
            backgroundSize: "330px , 200px , 180px"
        },
        ".jira-product-discovery-tabs .tab-panel img": {
            alignSelf: "flex-start",

            [media.below.sm]: {
                order: "-1"
            }
        }
    });

    return (
        <section className="tabSection" css={tabsSectionStyle}>
            <TabsQuote
                id="tabs-section"
                label="Tabs"
                headerText={headerText}
                bodyText=""
                tabs={tabs}
                colors={{
                    defaultBG: "#ffffff",
                    defaultText: "#505f79",
                    activeBG: "#0065ff",
                    activeText: "#ffffff",
                    hoverBG: "#ffffff",
                    hoverText: "#505f79"
                }}
                className="jira-product-discovery-tabs"
            />
            <div className="horizontal-rule">
                <Row layout="10">
                    <hr />
                </Row>
            </div>
        </section>
    );
};

export default TabsSection;
